import {
  Button,
  CircularProgress,
  Grid,
  Pagination,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import MiniDrawer from "../../Components/Drawer";
import BaseColor from "../../Config/Color";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getApiData } from "../../Apis/apiHelper";
import BaseSetting from "../../Apis/setting";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { Delete, Edit } from "@mui/icons-material";
import CModal from "../../Components/CModal";
import { FontFamily } from "../../Config/theme";
import CInput from "../../Components/CInput";
import CButton from "../../Components/CButton";
import _ from "lodash";
import { createSearchParams, useSearchParams } from "react-router-dom";

const NotificationTemplate = () => {
  const searchRef = useRef();

  //notification data
  const [notificationTemplateData, setnotificationTemplateData] = useState([]);

  // pagination and loaders
  const [pageLoad, setPageLoad] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pagination, setPagination] = useState();
  const [dataLoader, setDataLoader] = useState(false);

  //modal
  const [isEdit, setIsEdit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [viewMoreModal, setViewMoreModal] = useState();
  const [showData, setShowData] = useState("");
  const [disableNameInput, setDisableNameInput] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [notificationCount, setNotificationCount] = useState(0);

  //search and sort
  const [searchVal, setSearchVal] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [rowChange, setRowChange] = useState(false);

  //get params from URL
  const isPage = searchParams.get("page");
  const page = isPage > 1 ? Number(isPage) : 1;
  const search = searchParams.has("search") ? searchParams.get("search") : "";
  const sortVal = searchParams.has("sort") ? searchParams.get("sort") : "";
  const sortByVal = searchParams.has("sort_by")
    ? searchParams.get("sort_by")
    : "";
  const downloadId = searchParams.has("download_id")
    ? searchParams.get("download_id")
    : [];

  const downloadIdArr = searchParams.has("download_id")
    ? searchParams
        .get("download_id")
        ?.split(",")
        .map((str) => parseInt(str, 10))
    : [];
  const dataGridRef = useRef();
  const getDataGridApi = (api) => {
    dataGridRef.current = api;
  };
  const [delIds, setDelIds] = useState(downloadIdArr);

  useEffect(() => {
    setHeaderParams(page, search, sortVal, sortByVal, downloadId);
    setTimeout(() => {
      setRowChange(true);
    }, 500);
  }, []);

  //set params to URL
  const setHeaderParams = (
    page,
    search = "",
    sort = "",
    sortBy = "",
    download_id = []
  ) => {
    const params = {
      page: page,
    };

    setPageNo(page);
    if (!_.isEmpty(search)) {
      setSearchVal(search?.trim());
    }
    if (!_.isEmpty(search)) {
      params.search = search;
    }
    if (!_.isEmpty(sort)) {
      params.sort = sort;
    }
    if (!_.isEmpty(sortBy)) {
      params.sort_by = sortBy;
    }
    if (!_.isEmpty(download_id)) {
      params.download_id = download_id;
    }
    setSearchParams(createSearchParams(params));
  };

  //create update state
  const [templateName, setTemplateName] = useState("");
  const [templateTitle, setTemplateTitle] = useState("");
  const [notificationDesc, setnotificationDesc] = useState("");
  const [editData, setEditData] = useState();
  const [disableBtn, setDisableBtn] = useState(false);
  const [btnLoad, setBtnLoad] = useState(false);
  const [yesBtnLoading, setYesBtnLoading] = useState(false);

  //validation
  const [templateNameErrorText, setTemplateNameErrorText] = useState("");

  useEffect(() => {
    setPageLoad(true);
    getAllnotificationTemplateApiCall(page, search, sortVal, sortByVal);
  }, []);

  //all notification template data
  const getAllnotificationTemplateApiCall = (page, search, sort, sortBy) => {
    const data = {
      page: page,
      type: "admin",
    };

    if (!_.isEmpty(search)) {
      data.searchVal = search?.trim();
    }

    if (!_.isEmpty(sort)) {
      data.sort = sort;
    }

    if (!_.isEmpty(sortBy)) {
      data.sort_by = sortBy;
    }
    getApiData(BaseSetting.endpoint.getNotificationTemplates, "post", data)
      .then((result) => {
        if (result?.status) {
          const response = result?.data;
          setnotificationTemplateData(response?.templates);
          setPagination(response?.pagination);
          setNotificationCount(response?.count);
          setTimeout(() => {
            setDataLoader(false);
            setPageLoad(false);
          }, 100);
        } else {
          toast(result?.message, { type: "error" });
          setPageLoad(false);
          setDataLoader(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setPageLoad(false);
      });
  };

  // change status
  const changeStatus = (id) => {
    const endpoint = BaseSetting.endpoint.changeNotificationStatus;
    getApiData(endpoint, "post", { id: id })
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          getAllnotificationTemplateApiCall(pageNo, true);
        } else {
          toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  };

  const allErrorFalse = () => {
    setTemplateNameErrorText("");
  };

  const handleClose = () => {
    setOpenModal(false);
    setIsEdit(false);
    setDisableNameInput(false);
    setEditData("");
    allErrorFalse();
    setTemplateName("");
    setnotificationDesc("");
    setTemplateTitle("");
  };

  const validation = (type) => {
    if (templateName.trim() === "") {
      allErrorFalse();
      setTemplateNameErrorText("Template name is required");
    } else {
      allErrorFalse();
      createAndUpdatenotificationTemplate(type === "update");
    }
  };

  // create and update notification template api
  const createAndUpdatenotificationTemplate = (isUpdate) => {
    setBtnLoad(true);
    setDisableBtn(true);

    const endpoint = isUpdate
      ? BaseSetting.endpoint.updateNotificationTemplate
      : BaseSetting.endpoint.createNotificationTemplate;
    let data = {
      name: templateName,
      title: templateTitle,
      message: notificationDesc,
    };

    if (isUpdate) {
      data.id = editData?.id;
    }
    getApiData(endpoint, "POST", data)
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          setBtnLoad(false);
          setDisableBtn(false);
          handleClose();
          getAllnotificationTemplateApiCall(pageNo, true);
        } else {
          toast(result?.message, { type: "error" });
          setBtnLoad(false);
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setBtnLoad(false);
        setDisableBtn(false);
      });
  };

  //delete template
  const deleteTemplate = () => {
    setYesBtnLoading(true);
    const endpoint = BaseSetting.endpoint.deleteNotificationTemplate;
    getApiData(endpoint, "post", { id: !_.isEmpty(delIds) ? delIds : deleteId })
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          setYesBtnLoading(false);
          setConfirm(false);
          setDeleteId("");
          setDelIds([]);
          getAllnotificationTemplateApiCall(pageNo, true);
          const newIndex = notificationTemplateData.filter(
            (data) => data.id !== delIds
          );
          setnotificationTemplateData(newIndex);
        } else {
          toast(result?.message, { type: "error" });
          setYesBtnLoading(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setYesBtnLoading(false);
      });
  };

  const openTheModal = (data) => {
    setIsEdit(true);
    setEditData(data);
    setDisableNameInput(true);
    setOpenModal(true);
    setnotificationDesc(data?.message);
    setTemplateTitle(data?.title);
    setDisableNameInput(true);
    setTemplateName(data?.name);
  };

  const notificationTemplateColumn = [
    {
      field: "id",
      headerName: "NO.",
      flex: 0.2,
      minWidth: 70,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const newStartIndex = (pageNo - 1) * pagination?.defaultPageSize + 1;
        notificationTemplateData.map((data, i) => {
          data.serialNumber = i + newStartIndex;
        });
        return (
          <Typography style={{ fontFamily: FontFamily.SemiBold }}>
            {params?.row?.serialNumber}
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: "ACTIONS",
      width: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Grid container alignItems={"center"} justifyContent={"center"}>
            <Grid item>
              <Tooltip title="Edit" placement="top" arrow>
                <Button
                  onClick={() => {
                    openTheModal(params?.row);
                  }}
                >
                  <Edit style={{ fontSize: 20 }} />
                </Button>
              </Tooltip>
            </Grid>
            {_.isEmpty(delIds) ? (
              <Grid item>
                <Tooltip title="Delete" placement="top" arrow>
                  <Button
                    onClick={() => {
                      setConfirm(true);
                      setDeleteId(params?.row?.id);
                    }}
                  >
                    <Delete style={{ color: BaseColor.red, fontSize: 20 }} />
                  </Button>
                </Tooltip>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        );
      },
    },
    {
      field: "name",
      headerName: "TEMPLATE NAME",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "title",
      minWidth: 200,
      headerName: "TITLE",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "message",
      headerName: "NOTIFICATION DESC.",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "slug",
      minWidth: 150,
      headerName: "SLUG",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "STATUS",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => {
        return (
          <Switch
            checked={params?.row?.status === "active" ? true : false}
            onChange={() => changeStatus(params?.row?.id)}
          />
        );
      },
    },
  ];
  return (
    <Grid container>
      <MiniDrawer
        header="Notification Template"
        children={
          <>
            <Grid justifyContent={"space-between"} container>
              <Button variant="contained" onClick={() => setOpenModal(true)}>
                Create notification template
              </Button>
              <div style={{ display: "flex" }}>
                {!_.isEmpty(search) ||
                !_.isEmpty(sortVal) ||
                !_.isEmpty(sortByVal) ||
                !_.isEmpty(downloadId) ||
                !_.isEmpty(delIds) ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (dataGridRef.current) {
                        dataGridRef.current.setFilterModel({
                          items: [],
                          quickFilter: "",
                        });
                      }
                      setHeaderParams(page, "", "", "", []);
                      setDataLoader(true);

                      getAllnotificationTemplateApiCall(page);
                      setDelIds([]);
                      setSearchVal("");
                    }}
                    style={{ marginRight: "20px" }}
                  >
                    Clear filters
                  </Button>
                ) : null}
                {!_.isEmpty(delIds) ? (
                  <Button
                    variant="outlined"
                    style={{ color: "red", borderColor: "red" }}
                    onClick={() => {
                      setConfirm(true);
                    }}
                  >
                    Delete
                  </Button>
                ) : (
                  ""
                )}
                <div
                  style={{
                    border: `2px solid ${BaseColor.primary}`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "5px 15px",
                    borderRadius: "10px",
                    marginLeft: "20px",
                  }}
                >
                  Sent notification by today: {notificationCount}
                </div>
              </div>
            </Grid>

            <Grid container mt={"30px"}>
              {pageLoad ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "50vh",
                  }}
                >
                  <CircularProgress
                    style={{ color: BaseColor.primary }}
                    size={30}
                  />
                </div>
              ) : (
                <DataGrid
                  sortModel={
                    sortByVal === "asc" || sortByVal === "desc"
                      ? [
                          {
                            field: sortVal,
                            sort: sortByVal,
                          },
                        ]
                      : []
                  }
                  onSortModelChange={(model) => {
                    setDataLoader(true);
                    if (!_.isEmpty(model)) {
                      setHeaderParams(
                        isPage,
                        search,
                        model[0]?.field,
                        model[0].sort,
                        downloadId
                      );
                      getAllnotificationTemplateApiCall(
                        page,
                        search,
                        model[0]?.field,
                        model[0].sort
                      );
                    } else {
                      setHeaderParams(isPage, search, "", "", downloadId);
                      getAllnotificationTemplateApiCall(page, search);
                    }
                  }}
                  disableColumnFilter
                  disableColumnSelector
                  rows={notificationTemplateData}
                  columns={notificationTemplateColumn}
                  disableColumnMenu
                  disableDensitySelector
                  sortingMode="server"
                  apiRef={getDataGridApi}
                  hideFooter={isEmpty(delIds)}
                  hideFooterPagination
                  loading={dataLoader}
                  checkboxSelection
                  rowSelectionModel={delIds}
                  keepNonExistentRowsSelected
                  paginationMode="server"
                  onRowSelectionModelChange={(id) => {
                    setDelIds(id);
                    const downloadIdString = id.join(",");

                    setHeaderParams(
                      page,
                      search,
                      sortVal,
                      sortByVal,
                      downloadIdString
                    );
                    getAllnotificationTemplateApiCall(
                      page,
                      search,
                      sortVal,
                      sortByVal,
                      downloadIdString
                    );
                  }}
                  showCellVerticalBorder={true}
                  showColumnVerticalBorder={true}
                  disableSelectionOnClick
                  disableRowSelectionOnClick
                  autoHeight={true}
                  getRowHeight={() => "auto"}
                  slots={{ toolbar: GridToolbar }}
                  initialState={{
                    filter: {
                      filterModel: {
                        items: [],
                        quickFilterValues: [searchVal],
                      },
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root button svg.MuiSvgIcon-fontSizeSmall":
                      {
                        display: "none",
                        backgroundColor: "red",
                      },
                    "& .css-dwjt6a-MuiButtonBase-root-MuiIconButton-root": {
                      display: "none",
                    },
                    "&:hover .css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                      {
                        background: "#674188",
                      },
                    ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar":
                      {
                        width: "1px",
                        height: "4px",
                      },
                    ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-track":
                      {
                        background: "#F7EFE5",
                      },
                    ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                      {
                        background: "rgba(103, 65, 136, 0.5)",
                        borderRadius: "10px",
                      },
                  }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                      showQuickFilter: true,
                      onChange: (e) => {
                        setDataLoader(true);
                        setSearchVal(e.target.value?.toLowerCase());
                        setHeaderParams(
                          1,
                          e?.target?.value?.toLowerCase(),
                          sortVal,
                          sortByVal,
                          downloadId
                        );
                        if (searchRef.current) clearTimeout(searchRef.current);
                        searchRef.current = setTimeout(() => {
                          getAllnotificationTemplateApiCall(
                            1,
                            e?.target?.value?.toLowerCase(),
                            sortVal,
                            sortByVal
                          );
                        }, 800);
                      },
                    },
                  }}
                />
              )}
            </Grid>
            {!isEmpty(notificationTemplateData) && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={pagination?.totalPage}
                  page={page}
                  siblingCount={2}
                  onChange={(e, value) => {
                    setPageNo(value);
                    setPageLoad(true);
                    setHeaderParams(
                      value,
                      search,
                      sortVal,
                      sortByVal,
                      downloadId
                    );
                    getAllnotificationTemplateApiCall(
                      value,
                      search,
                      sortVal,
                      sortByVal
                    );
                  }}
                  sx={{ display: pageLoad ? "none" : "block" }}
                />
              </div>
            )}
          </>
        }
      />
      <CModal
        visible={openModal}
        onClose={() => {
          handleClose();
          allErrorFalse();
        }}
        title={
          isEdit
            ? "Update notification template"
            : "Create notification template"
        }
        style={{ width: "50%" }}
        children={
          <>
            <Grid container item xs={8} padding={"30px"} gap={2}>
              <Grid container gap={2} justifyContent={"space-between"}>
                <Grid item xs={12} md={12} lg={12}>
                  <CInput
                    placeholder="Template name"
                    value={templateName}
                    readOnly={disableNameInput}
                    onChange={(val) => {
                      setTemplateName(val);
                      setTemplateNameErrorText("");
                    }}
                    errorMsg={templateNameErrorText}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <CInput
                    placeholder="Template title"
                    value={templateTitle}
                    onChange={(val) => {
                      setTemplateTitle(val);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <CInput
                    placeholder=" Notification description"
                    multiline
                    rows={8}
                    value={notificationDesc}
                    onChange={(val) => {
                      setnotificationDesc(val);
                    }}
                  />
                </Grid>

                <Grid
                  container
                  justifyContent={"space-evenly"}
                  gap={2}
                  wrap="nowrap"
                >
                  <Grid item xs={6}>
                    <CButton
                      onClick={() =>
                        isEdit ? validation("update") : validation("create")
                      }
                      fullWidth
                      variant="contained"
                      disabled={disableBtn}
                      loading={btnLoad}
                    >
                      {!isEdit ? "Create" : "Update"}
                    </CButton>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      style={{ marginRight: "20px" }}
                      onClick={() => {
                        handleClose();
                        allErrorFalse();
                      }}
                      disabled={disableBtn}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
      <CModal
        visible={confirm}
        onClose={() => {
          setConfirm(false);
          setDeleteId("");
        }}
        title={"Delete Notification template"}
        children={
          <>
            <Grid container padding={"30px 0px"}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    marginBottom: 15,
                    fontFamily: FontFamily.Medium,
                    fontSize: 20,
                    textAlign: "center",
                  }}
                >
                  Are you sure, you want to delete this template ?
                </Typography>
              </Grid>
              <Grid container justifyContent={"center"} gap={2} wrap="nowrap">
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="outlined"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      setConfirm(false);
                      setDeleteId("");
                    }}
                  >
                    No
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <CButton
                    onClick={() => deleteTemplate()}
                    fullWidth
                    variant="contained"
                    loading={yesBtnLoading}
                  >
                    Yes
                  </CButton>
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
      <CModal
        visible={viewMoreModal}
        onClose={() => {
          setViewMoreModal(false);
        }}
        title={"Read more"}
        style={{ width: "50%" }}
        children={
          <div style={{ padding: "20px" }}>
            <div dangerouslySetInnerHTML={{ __html: showData }} />
          </div>
        }
      />
    </Grid>
  );
};

export default NotificationTemplate;
